/**
 * filterBom.ts
 *
 * Filter logic for flattened BOM rows (Excel-style per-column substring search).
 */

export function filterFlatBomRows<T extends Record<string, any>>(
  rows: T[],
  filters: Record<string, string>,
): T[] {
  return rows.filter((row) => {
    for (const [key, filterVal] of Object.entries(filters)) {
      if (!filterVal || !filterVal.trim()) continue
      const targetStr = String(row[key] ?? '').toLowerCase()
      if (!targetStr.includes(filterVal.trim().toLowerCase())) {
        return false
      }
    }
    return true
  })
}
